import { OrganisationsStackParamsList } from './types';

export const LinkingConfiguration = {
	Organisations: {
		path: '/organizations',
		exact: true,
		screens: {
			Home: '/:uuid',
			EditOrganisation: '/:uuid/edit',
			NewOrganisationMember: '/:organisationUuid/members/new',
			ImportOrganisationMember: '/:organisationUuid/members/import',
			CareRecipientCreatedConfirmation: '/:organisationUuid/members/:memberId/confirmation',
			FillCareRecipientInformation: '/:organisationUuid/members/:memberId/fill-information',
			FillCareRecipientInformationConfirmation:
				'/:organisationUuid/members/:memberId/fill-information/confirmation',

			NewTeam: '/:organisationUuid/teams/:parentTeamUuid?/new',
			EditTeam: '/:organisationUuid/teams/:uuid/edit',
			OrganisationTeam: '/:organisationUuid/teams/:teamUuid',

			AllTermsOfUse: '/:uuid/terms-of-use',
			NewTermsOfUse: '/:uuid/terms-of-use/new',
			AcceptTermsOfUse: '/:uuid/terms-of-use/accept',

			Invitations: '/:organisationUuid/invitations',
			NewTemporaryAccess: '/:organisationUuid/members/:memberId?/temporary-access/new',
		} as Record<keyof OrganisationsStackParamsList, string | object>,
	},
};
